import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/styles";
import moment from "moment";
import { forwardRef, useEffect, useState } from "react";
import { splitNumber } from "../../../utils/helper";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const ZOutReportPrint = forwardRef((props, ref) => {
  const { reportData, t, date } = props;
  const [userState, setUserState] = useState({});

  useEffect(() => {
    const data = localStorage.getItem("userDetails");
    if (data) {
      const userDetails = JSON.parse(data);
      setUserState(userDetails?.hotelDetail);
    }
  }, []);

  return (
    <div ref={ref}>
      {/* <style type="text/css" media="print">
        {`
      @page {
        size: landscape;
      }
    `}
      </style> */}
      <style type="text/css" media="print">
        {
          "\
  @page { size: portrait; }\
"
        }
      </style>
      {/* Footer */}

      <div className="d-flex mb-2 mt-2 justify-content-between">
        <h1>
          {t("Z - Out Report")} {": "}
          {userState?.company_name}
        </h1>
        <h1>
          {t("Hotel Date")} {": "}
          {date}
        </h1>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          borderTop: "2px solid",
          marginTop: "10px",
        }}
      ></div>
      <Grid container spacing={0.5} className="pl-2 pr-2 mt-3">
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h4" sx={{ fontSize: "17px" }}>
            {t("Advance Deposits Previous Balance")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h4" sx={{ fontSize: "17px" }}>
            $ {(+reportData?.advance_deposit_pre_bal || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {" "}
        </Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 3 }}>
            {t("Net Advance Payments")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.net_adv_pay || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 3 }}>
            {t("Plus T/A Commissions")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.plus_ta_comm || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 3 }}>
            {t("Refund By Check")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.refund_by_check || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 3 }}>
            {t("Refund By Cash or Credit Card")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.refund_by_cash_or_card || 0).toFixed(2)}
          </Typography>
        </Grid>

        <Grid item xs={12}></Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 1 }}>
            {t("Total Advance Deposit Credit")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.total_adv_dep_credits || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={12}></Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h6" sx={{ fontSize: "16px", ml: 1 }}>
            {t("Applied Deposits")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h6" sx={{ fontSize: "16px" }}>
            $ {(+reportData?.applied_deposit || 0).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={12}></Grid>
        <Grid
          item
          xs={8}
          // lg={4}
        >
          <Typography variant="h4" sx={{ fontSize: "17px" }}>
            {t("Advance Deposits Ending Balance")}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          // lg={8}
        >
          <Typography variant="h4" sx={{ fontSize: "17px" }}>
            $ {(+reportData?.adv_dep_ending_bal || 0).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
      <div className="px-2 my-2">
        <Typography variant="h4" sx={{ fontSize: "22px!important" }}>
          {t("Bank Deposits")}
        </Typography>
      </div>
      <div className="px-2">
        <Table
          // className="mt-2"
          size="small"
          sx={{
            borderCollapse: "collapse",
            // overflowX: "auto",
            "& .MuiTableCell-sizeSmall": {
              padding: "6px",
            },
            "& .MuiTableCell-root": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              wordBreak: "break-word",
            },
            minWidth: "600px",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Pay Type")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Guest Ledger")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("City Ledger")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Adv Dep Ledger")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Total")}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData?.bank_deposits?.map((item) => {
              return (
                <StyledTableRow>
                  <TableCell item xs={4}>
                    {item?.pay_type}
                  </TableCell>
                  <TableCell item xs={4}>
                    {(+item?.guest_ledger || 0).toFixed(2)}
                  </TableCell>
                  <TableCell item xs={4}>
                    {(+item?.city_ledger || 0).toFixed(2)}
                  </TableCell>
                  <TableCell item xs={4}>
                    {(+item?.adv_deposit_ledger || 0).toFixed(2)}
                  </TableCell>
                  <TableCell item xs={4}>
                    <b>{(+item?.total || 0).toFixed(2)}</b>
                  </TableCell>
                </StyledTableRow>
              );
            })}

            <TableRow sx={{ borderTop: "2px solid black" }}>
              <TableCell item xs={4}>
                <b>Total</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>
                  {reportData?.bank_deposits
                    ?.reduce((sum, item) => {
                      return sum + (+item.guest_ledger || 0); // Convert to number and add to the sum
                    }, 0)
                    .toFixed(2)}
                </b>
              </TableCell>
              <TableCell item xs={4}>
                <b>
                  {reportData?.bank_deposits
                    ?.reduce((sum, item) => {
                      return sum + (+item.city_ledger || 0); // Convert to number and add to the sum
                    }, 0)
                    .toFixed(2)}
                </b>
              </TableCell>
              <TableCell item xs={4}>
                <b>
                  {reportData?.bank_deposits
                    ?.reduce((sum, item) => {
                      return sum + (+item.adv_deposit_ledger || 0); // Convert to number and add to the sum
                    }, 0)
                    .toFixed(2)}
                </b>
              </TableCell>
              <TableCell item xs={4}>
                <b>
                  {reportData?.bank_deposits
                    ?.reduce((sum, item) => {
                      return sum + (+item.total || 0); // Convert to number and add to the sum
                    }, 0)
                    .toFixed(2)}
                </b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div className="px-2 my-2">
        <Typography variant="h4" sx={{ fontSize: "22px!important" }}>
          {t("Deposits By Clerk")}
        </Typography>
      </div>
      <div className="px-2">
        <Table
          // className="mt-2"
          size="small"
          sx={{
            borderCollapse: "collapse",
            overflowX: "auto",
            "& .MuiTableCell-sizeSmall": {
              padding: "6px",
            },
            "& .MuiTableCell-root": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              wordBreak: "break-word",
            },
            minWidth: "600px",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Clerk")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("CASH")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("AMEX")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("VISA")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("DINERS")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("DISCOVER")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("CART BLA")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("MASTER C")}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <StyledTableRow>
              <TableCell item xs={4}>
                CO
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
              <TableCell item xs={4}>
                0.00
              </TableCell>
            </StyledTableRow>

            <TableRow sx={{ borderTop: "2px solid black" }}>
              <TableCell item xs={4}>
                <b>Total</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
              <TableCell item xs={4}>
                <b>0.00</b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      {/* <div style={{breakBefore: "page"}}></div> */}
      <div className="px-2 my-2">
        <Typography variant="h4" sx={{ fontSize: "22px!important" }}>
          {t("Sales Batch")}
        </Typography>
      </div>
      <div
        className="d-flex mb-2 mt-2 justify-content-between"
        style={{
          borderTop: "1px solid black",
          borderBottom: "1px solid black",
          margin: "0px 20px",
          padding: "10px 0px",
        }}
      >
        <h4>
          {t("Sales Batch")} {": "}
          {userState?.company_name}
        </h4>
        <h1>
          {t("Hotel Date")} {": "}
          {date}
        </h1>
      </div>
      <div className="px-2">
        <Table
          // className="mt-2"
          size="small"
          sx={{
            borderCollapse: "collapse",
            overflowX: "auto",
            "& .MuiTableCell-sizeSmall": {
              padding: "6px",
            },
            "& .MuiTableCell-root": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              wordBreak: "break-word",
            },
            minWidth: "600px",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Shift /Staff /Clerk")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Booking Id")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Room")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Pay")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("How")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Pending Sale")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Auth")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Credit Card#")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Expr")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Card Holder")}
                </Typography>
              </TableCell>
              {/* <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Handle")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Trans ID")}
                </Typography>
              </TableCell> */}
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Retrival Reference")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Invoice")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h4" style={{ fontSize: "15px" }}>
                  {t("Date & Time")}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData?.sales_batch &&
              Object.entries(reportData?.sales_batch)?.map(([Key, items]) => (
                <>
                  <TableRow
                    sx={{
                      borderTop: "2px solid black",
                      borderBottom: "2px solid black",
                    }}
                  >
                    <TableCell colSpan={12}>
                      <Typography
                        variant="h4"
                        sx={{ fontSize: "16px!important" }}
                      >
                        Sales For: {Key}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  {items?.map((item) => (
                    <StyledTableRow>
                      <TableCell item xs={4}>
                        {item?.shift}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.booking_id}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.room}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.pay}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.how}
                      </TableCell>
                      <TableCell item xs={4}>
                        {(+item?.pending_sale).toFixed(2)}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.auth}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.credit_card}
                      </TableCell>
                      <TableCell item xs={4}>
                        {splitNumber(item?.expr)}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.card_holder}
                      </TableCell>
                      {/* <TableCell item xs={4}>
                        [{+item?.handle === 0 ? " " : item?.handle}]
                      </TableCell>
                      <TableCell item xs={4}>
                        {+item?.trans_id === 0 ? " " : item?.trans_id}
                      </TableCell> */}
                      <TableCell item xs={4}>
                        {item?.retrieval_reference}
                      </TableCell>
                      <TableCell item xs={4}>
                        {item?.invoice}
                      </TableCell>
                      <TableCell item xs={4}>
                      { moment.utc(item?.date_time).local().format("MM/DD/YYYY HH:mm A")}
                      </TableCell>
                    </StyledTableRow>
                  ))}

                  <TableRow sx={{ borderTop: "2px solid black" }}>
                    <TableCell colSpan={12}>
                      <div className="d-flex gap-2">
                        <span> Sub Total :</span>{" "}
                        <span> Count : {items?.length}</span>{" "}
                        <span>
                          {" "}
                          Total Sale : ${" "}
                          {items
                            ?.reduce((sum, item) => {
                              return sum + (+item.pending_sale || 0); // Convert to number and add to the sum
                            }, 0)
                            .toFixed(2)}
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                </>
              ))}
            <TableRow sx={{ borderTop: "2px solid black" }}>
              <TableCell colSpan={12}></TableCell>
            </TableRow>
            <TableRow sx={{ borderTop: "2px solid black" }}>
              <TableCell colSpan={12}>
                <div id="font-600" className="d-flex gap-2">
                  <span> Total :</span>{" "}
                  <span>
                    {" "}
                    Count :{" "}
                    {reportData?.sales_batch &&
                      Object.entries(reportData?.sales_batch)?.reduce(
                        (sum, [key, items]) => {
                          return sum + items?.length;
                        },
                        0
                      )}
                  </span>{" "}
                  <span>
                    {" "}
                    Total Sale : $
                    {reportData?.sales_batch &&
                      Object.entries(reportData?.sales_batch)
                        ?.reduce((sum, [key, items]) => {
                          return (
                            sum +
                            +items?.reduce((sum, item) => {
                              return sum + (+item.pending_sale || 0); // Convert to number and add to the sum
                            }, 0)
                          );
                        }, 0)
                        .toFixed(2)}
                  </span>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      {/* <div className="px-2">
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          Transmitted: {date} batch
          for {date} - H
        </Typography>
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          Sales transactions successfully transmitted
        </Typography>

        {reportData?.sales_batch &&
          Object.entries(reportData?.sales_batch)?.map(([Key, items]) => (
            <>
              {items?.map((item) => (
                <Grid container spacing={2}>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.shift}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.room}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.pay}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.how}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {(+item?.pending_sale).toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.auth}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.credit_card}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {splitNumber(item?.expr)}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.card_holder}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      [{+item?.handle === 0 ? " " : item?.handle}]
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {+item?.trans_id === 0 ? " " : item?.trans_id}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.retrieval_reference}
                    </Typography>
                  </Grid>

                  <Grid item>
                    <Typography sx={{ fontStyle: "italic" }} variant="h4">
                      {item?.invoice}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </>
          ))}
      </div>
      <div
        className="mx-1 px-1 my-2 py-2"
        style={{ borderTop: "1px solid black", width: "100%" }}
      >
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          <span> Totals :</span>{" "}
          <span>
            {" "}
            Count :{" "}
            {reportData?.sales_batch &&
              Object.entries(reportData?.sales_batch)?.reduce(
                (sum, [key, items]) => {
                  return sum + items?.length;
                },
                0
              )}
          </span>{" "}
          <span className="ml-2">
            {" "}
            Total Sale : $
            {reportData?.sales_batch &&
              Object.entries(reportData?.sales_batch)
                ?.reduce((sum, [key, items]) => {
                  return (
                    sum +
                    +items?.reduce((sum, item) => {
                      return sum + (+item.pending_sale || 0); // Convert to number and add to the sum
                    }, 0)
                  );
                }, 0)
                .toFixed(2)}
          </span>
        </Typography>
      </div>
      <div className="px-2">
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          Sales Batch Transmission OK [/]
        </Typography>
      </div> */}
      <div className="px-2">
        <Typography sx={{ fontStyle: "italic" }} variant="h4">
          Print Date: {moment().format("MM/DD/YYYY hh:mm A")}
        </Typography>
      </div>
    </div>
  );
});

export default ZOutReportPrint;
